const moduleNameRegex = /\/([^/]+)\/.*?\.js$/;

const contexts = {
    reducers: require.context('./modules', true, /index\.js$/),
    actions: require.context('./modules', true, /actions\.js$/),
};

/**
 * Loop through the contexts object defined above
 * and create an object with all the reducers and actions
 */
const loadedContexts = Object.keys(contexts).reduce((result, key) => {
    const context = contexts[key];
    result[key] = context.keys().reduce((modules, moduleString) => {
        // Get the name from the moduleString
        const [, name] = moduleString.match(moduleNameRegex);

        // '.default' is needed for old commonJS files
        modules[name] = context(moduleString).default || context(moduleString);
        return modules;
    }, {});

    result[key] = Object.freeze(result[key]);

    return result;
}, {});

export default Object.freeze(loadedContexts);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/index.js